/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface EmployeesMercerJobCodesCreateMercerJobCodeAssignmentsExportModel {
  ids?: Array<string> | null;
  exportType?: EmployeesMercerJobCodesCreateMercerJobCodeAssignmentsExportModelExportTypeEnum;
  state?: EmployeesMercerJobCodesCreateMercerJobCodeAssignmentsExportModelStateEnum;
  filename?: string | null;
}
export enum EmployeesMercerJobCodesCreateMercerJobCodeAssignmentsExportModelExportTypeEnum {
  Current = 'Current',
  Full = 'Full'
}
export enum EmployeesMercerJobCodesCreateMercerJobCodeAssignmentsExportModelStateEnum {
  Open = 'Open',
  Done = 'Done'
}
